import React from 'react';
import * as S from './styles';
const LogoSection = ({ logoItems }) => (React.createElement(S.Wrapper, null, logoItems.map(({ id, href, url, alt }) => (React.createElement(S.CustomLink, { key: id, href: href },
    React.createElement(S.CustomImage, { src: url, alt: alt }))))));
export default LogoSection;
//# sourceMappingURL=index.js.map